/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { B200, N20A, N30A, N40A, N50A } from '@atlaskit/theme/colors';
import { br, gs, mq } from '../../common/utils';
export var FrameOld = function FrameOld() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    isSelected: false,
    isHoverable: false,
    isFluidHeight: false
  };
  return props.compact ? jsx(CompactFrameOld, props) : jsx(ExpandedFrameOld, props);
};
var sharedBaseFrameStyles = css({
  width: '100%',
  display: 'flex'
});

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
var sharedFrameStyles = {
  maxWidth: gs(95),
  backgroundColor: "var(--ds-surface-raised, white)"
};
export var ExpandedFrameOld = function ExpandedFrameOld(_ref) {
  var children = _ref.children,
    isSelected = _ref.isSelected,
    isHoverable = _ref.isHoverable,
    testId = _ref.testId,
    className = _ref.className,
    isFluidHeight = _ref.isFluidHeight;
  return jsx("div", {
    css: [sharedBaseFrameStyles, sharedFrameStyles,
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    mq({
      '&:hover': isHoverable ? {
        // TODO: https://product-fabric.atlassian.net/browse/DSP-4064
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, ".concat(N20A, ")"),
        cursor: 'pointer'
      } : undefined,
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      minHeight: isFluidHeight ? 0 : [gs(21), gs(15)],
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      borderRadius: isSelected ? br() : br(0.5),
      border: "2px solid ".concat(isSelected ? "var(--ds-border-selected, ".concat(B200, ")") : 'transparent'),
      justifyContent: 'space-between',
      overflow: 'hidden',
      boxShadow: "var(--ds-shadow-raised, ".concat("0 1px 1px ".concat(N50A, ", 0 0 1px 1px ").concat(N40A), ")")
    })],
    "data-testid": testId
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: className,
    "data-trello-do-not-use-override": testId
  }, children);
};
export var CompactFrameOld = function CompactFrameOld(_ref2) {
  var children = _ref2.children,
    isHoverable = _ref2.isHoverable,
    isSelected = _ref2.isSelected,
    testId = _ref2.testId,
    className = _ref2.className,
    inheritDimensions = _ref2.inheritDimensions;
  return jsx("div", {
    css: [sharedBaseFrameStyles, sharedFrameStyles,
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    mq({
      '&:hover': isHoverable ? {
        backgroundColor: "var(--ds-background-neutral-hovered, ".concat(N30A, ")")
      } : undefined,
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      borderRadius: isSelected ? br() : br(0.5),
      border: isSelected ? "2px solid ".concat("var(--ds-border-selected, ".concat(B200, ")")) : '',
      justifyContent: 'center',
      alignItems: 'center',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      height: inheritDimensions ? '100%' : gs(5),
      backgroundColor: "var(--ds-background-neutral, ".concat(N20A, ")"),
      width: ['calc(100% - 16px)', '100%'],
      // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      padding: ["0px ".concat(gs(1)), '0']
    })],
    "data-testid": testId
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: className
  }, children);
};